export const strings = {
  // UI Titles & Descriptions
  PAGE_TITLE_ADVISOR: "Manage and Generate Investment Proposals",
  PAGE_SUBTITLE_ADVISOR:
    "Get started by choosing how to import current holdings.",

  PAGE_TITLE: "View Investment Proposals",
  PAGE_SUBTITLE: "View your shared investment proposals.",

  // Modal Titles & Labels
  NEW_PROPOSAL: "New Proposal",
  RENAME_PROPOSAL: "Rename Proposal",
  DELETE_PROPOSAL: "Delete Proposal",
  PROPOSAL_NAME: "Proposal Name",
  PROPOSAL_PLACEHOLDER: "Enter a name for your proposal",

  // Modal Confirmation Buttons
  CONFIRM_CONTINUE: "Continue",
  CONFIRM_RENAME: "Rename",
  CONFIRM_DELETE: "Delete",

  // Notification Messages (Creation/Update)
  PROPOSAL_CREATED: "Proposal created",
  ERROR_CREATING_PROPOSAL: "Error creating proposal ",
  ERROR_CREATING_PROPOSAL_GENERIC:
    "There was an error in creating a proposal. Please try again.",

  // Notification Messages (Delete)
  PROPOSAL_DELETED: "Proposal deleted",
  ERROR_DELETING_PROPOSAL: "Error deleting proposal ",
  ERROR_DELETING_PROPOSAL_GENERIC:
    "There was an error in deleting a proposal. Please try again.",

  // Notification Messages (Duplicated)
  PROPOSAL_DUPLICATED: "Proposal duplicated",
  ERROR_DUPLICATING_PROPOSAL: "Error duplicating proposal ",
  ERROR_DUPLICATING_PROPOSAL_GENERIC:
    "There was an error in duplicating a proposal. Please try again.",

  DOCUMENTS_PROCESSED: "Documents processed",
  ERROR_PROCESSING_DOCUMENTS: "Error processing documents",
  ERROR_PROCESSING_DOCUMENTS_GENERIC:
    "There was an error processing documents. Please try again.",

  // Error Messages (Missing Proposal)
  PROPOSAL_TO_UPDATE_UNDEFINED: "Proposal to update is undefined",
  PROPOSAL_TO_DELETE_UNDEFINED: "Proposal to delete is undefined",
  ADVISOR_ID_UNDEFINED: "Advisor ID is undefined",

  // Delete Modal Description Template (use a formatter function to replace {proposalName})
  DELETE_PROPOSAL_TEXT:
    'By selecting "Delete," you permanently remove "{proposalName}" Proposal. Please note that this action cannot be undone.',

  // Additional Titles & Descriptions
  DATA_PROCESSING_HEADER_TITLE: "We are working on it...",
  DATA_PROCESSING_HEADER_SUBTITLE: "This may take a few minutes",
  DATA_PROCESSING_FOOTER_TITLE: "Extracting Data",
  DATA_PROCESSING_FOOTER_SUBTITLE:
    "Feel free to navigate away—we’ll notify you as soon as it’s ready.",

  // Flow Titles & Descriptions
  FLOW_STEP_ADD_EXISTING_TITLE: "Start with a Farther Managed Account",
  FLOW_STEP_ADD_EXISTING_SUBTITLE:
    "Select the account(s) you wish to start with.",
  FLOW_STEP_ADD_STATEMENT_TITLE:
    "Select the document(s) you wish to import current holdings from.",
  FLOW_STEP_ADD_STATEMENT_SUBTITLE:
    "Choose from the following documents in the Document Center or upload a new one.",

  FLOW_STEP_START_TITLE: "View Investment Proposals",
  FLOW_STEP_START_SUBTITLE: "View your shared investment proposals.",

  HOLDINGS_UPDATED: "Holdings updated",
  ERROR_UPDATING_HOLDINGS: "Error updating holdings",
  ERROR_UPDATING_HOLDINGS_GENERIC:
    "There was an error updating the holdings. Please try again.",

  // Share proposal strings
  PROPOSAL_SHARED: "Proposal shared.",
  ERROR_SHARING_PROPOSAL: "Failed to share transition proposal",
  ERROR_SHARING_PROPOSAL_GENERIC:
    "Failed to share proposal. Please try again later.",
  SHARE_PROPOSAL_TITLE: "Share Proposal",
  SHARE_PROPOSAL_DESCRIPTION:
    "Are you sure you want to share this transition proposal with the client? This action cannot be undone.",
  SHARE_PROPOSAL_BUTTON: "Share Proposal",
  SHARING_BUTTON: "Sharing...",
  CANCEL_BUTTON: "Cancel",
} as const;
